import { Controller } from "@hotwired/stimulus"

const KEY = "pay-theme"

// Light or dark on <html data-theme>, remembered in the browser. `set` with
// an empty theme follows the system again.
export default class extends Controller {
  toggle() {
    this.apply(document.documentElement.dataset.theme === "dark" ? "light" : "dark")
  }

  set({ params }) {
    const theme = params.theme || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")

    this.apply(theme, params.theme || null)
  }

  apply(theme, stored = theme) {
    document.documentElement.dataset.theme = theme

    try {
      stored ? localStorage.setItem(KEY, stored) : localStorage.removeItem(KEY)
    } catch (e) {
      console.warn("theme not saved", e)
    }
  }
}
